/** @format */

const { innerWidth } = window;

export const IS_SMALLER_DEVICE = innerWidth < 1024 || innerWidth < 768;
